export default __webpack_public_path__ + "static/media/moviepack_why.1133097a.png";